import * as React from 'react';
import { Link } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ArrowDirection, ArrowIconWithMargin } from '@lean-body/components/atoms';
import { tvAnnoucementId } from '@lean-body/src/domain';
import { routes } from '@lean-body/src/route';
import { ONE_DAY_IN_MS } from '@lean-body/src/util';
import { LocalStorage } from '@lean-body/src/infra';
import { Colors, MediaBreakPointUp } from '../styles';
import { CLOSE_ROUND_ICON_DARk_GARY, CloseRoundIcon } from '../atoms/icons/close_round_icon';
import { ZIndex } from '../constants';
export const TV_CONNECTION_BANNER_XL_HEIGHT = 60;
export const isTvConnectionBannerVisible = () => {
    const dismissedAt = new LocalStorage().loadTvConnectionBannerDismissedAt;
    const yesterday = Date.now() - ONE_DAY_IN_MS;
    return !dismissedAt || dismissedAt < yesterday;
};
export const TvConnectionBanner = ({ config, isVisible, onClose, classObject }) => {
    const link = routes.ANNOUNCEMENT_DETAIL.compile({ id: tvAnnoucementId(config).toString() });
    const handleCloseClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onClose();
    };
    if (!isVisible) {
        return null;
    }
    return (React.createElement(Link, { to: link, className: css(styles.container, classObject) },
        React.createElement(CloseRoundIcon, { color: CLOSE_ROUND_ICON_DARk_GARY, onClick: handleCloseClick, containerClassObject: styles.icon }),
        React.createElement("div", { className: css(styles.text) },
            React.createElement("span", { className: css(styles.textLine) }, "\u30C6\u30EC\u30D3\u306E\u5927\u753B\u9762\u3067"),
            React.createElement("span", { className: css(styles.textLine) }, "\u30EC\u30C3\u30B9\u30F3\u3092\u697D\u3057\u307F\u307E\u3057\u3087\u3046\uFF01")),
        React.createElement("div", { className: css(styles.button) },
            React.createElement("span", { className: css(styles.buttonLabel) }, "\u63A5\u7D9A\u65B9\u6CD5\u3092\u898B\u308B"),
            React.createElement(ArrowIconWithMargin, { direction: ArrowDirection.right, color: TV_CONNECTION_BUTTON_COLOR, classObject: styles.buttonArrow }))));
};
const TV_CONNECTION_BUTTON_COLOR = '#FF4702';
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: 12,
        background: 'linear-gradient(87deg, #FF6001 0%, #FF4001 100%)',
        color: Colors.White,
        textDecoration: 'none',
        [MediaBreakPointUp.XL]: {
            position: 'fixed',
            bottom: 42,
            right: 20,
            borderRadius: 10,
            boxShadow: '0 4px 10px 0 rgba(133, 45, 14, 0.2)',
            maxWidth: 375,
            zIndex: ZIndex.HomePositionFixed,
        },
    },
    icon: {
        display: 'block',
        width: 25,
        height: 25,
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: 2,
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '140%',
    },
    textLine: {
        display: 'block',
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: Colors.White,
        color: TV_CONNECTION_BUTTON_COLOR,
        borderRadius: 20,
        padding: '10px 12px',
        fontSize: 13,
        fontWeight: 'bold',
        letterSpacing: '0.52px',
        lineHeight: '140%',
    },
    buttonLabel: {
        display: 'inline-block',
    },
    buttonArrow: {
        width: 16,
        height: 16,
    },
});
